import { type JSX } from 'react';

import { IMAGE_GENERATION_RATIO_OPTIONS, VIDEO_GENERATION_RATIO_OPTIONS } from '../../_context/constants';
import { AI_TOOLKIT_CATEGORIES, type AiToolkitCategory } from '../../_context/types';
import { SelectField, SelectFieldProps } from './SelectField';

export interface AspectRatioSelectFieldProps
    extends Omit<SelectFieldProps, 'label' | 'id' | 'options' | 'defaultValue'> {
    aiToolkitCategory: Extract<AiToolkitCategory, 'video-generation' | 'image-generation'>;
}

export const AspectRatioSelectField = ({
    aiToolkitCategory,
    selectTriggerProps,
    ...rest
}: AspectRatioSelectFieldProps): JSX.Element => {
    const options =
        aiToolkitCategory === AI_TOOLKIT_CATEGORIES.VIDEO_GENERATION
            ? VIDEO_GENERATION_RATIO_OPTIONS
            : aiToolkitCategory === AI_TOOLKIT_CATEGORIES.IMAGE_GENERATION
              ? IMAGE_GENERATION_RATIO_OPTIONS
              : [];

    return (
        <SelectField
            selectTriggerProps={{ name: 'aspect-ratio', ...selectTriggerProps }}
            {...rest}
            label="Aspect Ratio"
            id="aspect-ratio"
            name="aspect-ratio"
            options={options}
            defaultValue={options[0]?.value}
        />
    );
};
